var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"disclaimer"}},[_c('p',{staticClass:"disclaimer-text"},[_vm._v(" Нажимая кнопку “Отправить”,"),_c('br'),_vm._v("вы соглашаетесь с "),_c('a',{attrs:{"href":"https://docs.google.com/document/d/18ccRmhu1-tFramWheRfVQ4-iEGMckv7pKJm1pt-xSW0"}},[_vm._v("условиями использования")])])])
}]

export { render, staticRenderFns }